import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class FcmStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
    });
  }

  async subscribeFCM(token, topic) {
    this.loading = true;
    // console.log('subscribeFCM', token);
    try {
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/fcm/subscribe`, {
          authorization: true,
          body: {
            topic,
            token,
          },
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      console.log('subscribeFCM return :', res);
      return res;
    } catch (err) {
      console.log('subscribeFCM err', err);
    } finally {
      this.loading = false;
    }
  }

  async unSubscribeFCM(token, topic) {
    this.loading = true;
    console.log('unsubscribe', token);
    try {
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/fcm/unsubscribe`, {
          authorization: true,
          body: {
            topic,
            token,
          },
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      console.log('unsubscribe return :', res);
      return res;
    } catch (err) {
      console.log('unsubscribe err', err);
    } finally {
      this.loading = false;
    }
  }
}

export default new FcmStore();
